import template from './savedInsuranceProfilers.html';
import controller from './savedInsuranceProfilersCtrl.js';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    familyId: '<',
  },
};
